// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
if (!window.global) {
  window.global = window;
}
